<template>
    <transition name="c-fade-transition">
        <div class="vc-loading-modal" v-show="isShown">
            <div class="vc-loading-modal__content">
                <base-infinity-loading class="vc-loading-modal__content__spinner"></base-infinity-loading>
                <div class="vc-loading-modal__content__title">
                    {{title}}
                </div>
                <div class="vc-loading-modal__content__description">
                    <slot name="description"></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import BaseInfinityLoading from "./base-infinity-loading.vue"

    export default {
        name: "base-loading-modal",
        props: {
          title :{
              type: String,
              default: 'Please wait'
          }
        },
        components: {
            BaseInfinityLoading
        },
        data() {
            return {
                isShown: true,
            }
        },
        methods: {
            show() {
               this.isShown = true;
            },
            hide() {
                this.isShown = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .vc-loading-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: var(--background-faded-little);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;

        &__content {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            color: var(--primary-text-color);
            text-align: center;

            &__spinner {
                width: 130px;
            }
            &__title {
                font-weight: 600;
                font-size: 20px;
                color: var(--highlight-color);
            }
            &__description {
                font-size: 15px;
                color: var(--primary-text-color-emphasized);
            }
        }
    }
</style>